import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';

import styles from './testOverview.scss';
import TestComponentContent from './TestComponentContent';
import TestComponentReadinessCheck from './TestComponentReadinessCheck';
import TestComponentTestInfo from './TestComponentTestInfo';
import TestComponentSelector from '../../services/testOverview/TestComponentSelector';

// Keep component state-free AND service-free.
export class PureTestComponent extends React.PureComponent {
    static propTypes = {
        unwrapChild: PropTypes.bool,
        cacheStatus: PropTypes.object.isRequired,
        parentTest: PropTypes.object.isRequired,
        test: PropTypes.object.isRequired,
        isCompleted: PropTypes.bool.isRequired,
        navigationLock: PropTypes.object.isRequired,
        offlineFileDeliveryStatus: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
        pendingAssessments: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
        livestream: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types

        // resolved
        shouldHighlight: PropTypes.bool.isRequired,
        statusTextClassName: PropTypes.string.isRequired,
        statusCaption: PropTypes.string.isRequired,
        shouldRenderReadinessCheck: PropTypes.bool.isRequired,
        shouldRenderTestActions: PropTypes.bool.isRequired,
        shouldCacheReadinessResources: PropTypes.bool.isRequired,
        readinessCheckContentRevisionId: PropTypes.number,
        isPendingFileDeliveryUpload: PropTypes.bool.isRequired,
        totalDurationFormatted: PropTypes.string.isRequired,
    };

    static defaultProps = {
        unwrapChild: false,
    };

    render() {
        const {
            unwrapChild,
            cacheStatus,
            parentTest,
            test,
            isCompleted,
            navigationLock,
            shouldHighlight,
            statusTextClassName,
            statusCaption,
            shouldRenderReadinessCheck,
            shouldRenderTestActions,
            shouldCacheReadinessResources,
            readinessCheckContentRevisionId,
            isPendingFileDeliveryUpload,
            totalDurationFormatted,
        } = this.props;

        const icons = (
            <React.Fragment>
                {
                    isCompleted ?
                        <div className={styles.completed}>
                            <i className="fa fa-check" aria-hidden />
                        </div>
                        : null

                }
                {
                    isPendingFileDeliveryUpload ?
                        <div className={styles.uploadingIcon}>
                            <i className="fa fa-cloud-upload" aria-hidden />
                        </div>
                        : null
                }
            </React.Fragment>
        );

        return (
            <TestComponentContent
                className={`${styles.childTest} ${shouldHighlight ? styles.highlighted : ''}`}
                icons={icons}
                title={test.title}
                unwrapChild={unwrapChild}
            >
                <h4 className={statusTextClassName}>
                    {t(statusCaption)}
                </h4>
                {
                    test.duration ?
                        <p>{t('childTest.duration')}: {totalDurationFormatted}</p>
                        : null
                }
                {
                    shouldRenderReadinessCheck ?
                        <TestComponentReadinessCheck
                            title={test.title}
                            cacheStatus={cacheStatus}
                            shouldCacheResources={shouldCacheReadinessResources}
                            readinessCheckContentRevisionId={readinessCheckContentRevisionId}
                        />
                        : null
                }
                {
                    shouldRenderTestActions ?
                        <TestComponentTestInfo
                            test={test}
                            cacheStatus={cacheStatus}
                            parentTest={parentTest}
                            navigationLock={navigationLock}
                        />
                        : null
                }
            </TestComponentContent>
        );
    }
}

const TestComponent = (ownProps) => {
    const resolvedProps = TestComponentSelector.mapToProps(ownProps);
    return <PureTestComponent {...ownProps} {...resolvedProps} />;
};

export default TestComponent;
